<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Status Perjanjian'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'appointment-statuses'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/appointment-statuses/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Status Perjanjian", route: "" },
      { title: "Daftar Status Perjanjian", route: "/masters/appointment-statuses/list" },
      { title: "Tambah Status Perjanjian" },
    ])
  },

}

</script>